import React from "react";
import "rc-switch/assets/index.css";
import Select from "react-select";
import _ from "lodash";
import logger from "../../../utils/LoggerFrontend";
import ATSSingleAnswer from "./Campaign__Create_ATS__Answer.jsx";
import {
  DeleteButtonQuestion,
  QuestionSection,
  AnswersSection,
  AddAnswerPlaceholder,
  QuestionWrapper,
  QuestionNumberWrapper,
  QuestionEditing,
  SelectMenuStylesHidden,
  FreeFormText
} from "./Campaign__Create_ATS.styled";
import { withTranslation } from "react-i18next";

function convertFormalityToBoolean(formality) {
  return formality == "Sie" ? true : false;
}

class ATSSingleQuestion extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.ERROR__EMPTY_QUESTION = t("Please enter your question here.");
    this.state = {
      isQuestionBeingEdited: false,
      hasNewAnswer: false,
      questionError: props?.question?.question?.length ? false : this.ERROR__EMPTY_QUESTION,
      questionInput: props?.question?.question || ""
    };
    this.textAreaRef = React.createRef();
  }

  componentDidMount() {
    if (this.textAreaRef && this.textAreaRef.current && this.textAreaRef.current.style) {
      this.textAreaRef.current.style.height = this.textAreaRef.current.scrollHeight + "px";
    }
    if (this.props.isNewQuestion && this.textAreaRef && this.textAreaRef.current) {
      this.textAreaRef.current.focus();
      this.setState({ isQuestionBeingEdited: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.textAreaRef && this.textAreaRef.current && this.textAreaRef.current.style) {
      this.textAreaRef.current.style.height = this.textAreaRef.current.scrollHeight + "px";
    }
    if (prevProps?.question?.question != this.props?.question?.question) {
      this.setState({
        questionInput: this.props?.question?.question,
        questionError: this.props?.question?.question?.length ? false : this.ERROR__EMPTY_QUESTION
      });
    }
  }

  autosize(e) {
    var el = e.target;
    const { which } = e;
    logger.debug("ATSSingleQuestion:autosize", "called", { target: el, which });

    if ([27, 13].includes(which)) {
      logger.debug("ATSSingleQuestion:autosize", "enter pressed");
      this.setState({ isQuestionBeingEdited: false });
      el.blur();
      return;
    }

    setTimeout(function () {
      el.style.cssText = "height:auto";
      el.style.cssText = "-moz-box-sizing:content-box";
      el.style.cssText = "height:" + el.scrollHeight + "px";
    }, 0);
  }

  renderHistoricalQuestions() {
    const { isQuestionBeingEdited } = this.state;
    const { question, isNewQuestion, formality, historicalQuestions = [] } = this.props;
    const { question: questionTitle, key } = question;
    const formalityBoolean = convertFormalityToBoolean(formality);
    // Filter out previous questions based on question type and question formality
    let previousQuestions = _.filter(historicalQuestions, { key, isFormal: formalityBoolean });
    const options = _.uniq(previousQuestions).map((q) => ({ label: q.question, value: q }));

    // If question is being edited keep menu open
    let menuIsOpen = isQuestionBeingEdited && options.length;

    const searchOptions = (candidate, input) => {
      if (!input) {
        return true;
      }
      if (!candidate.label) {
        return true;
      }
      // If the typed in question is the same as the option being filtered
      // there is no need to show the option since it's already shown on the
      // input
      if (candidate.label.toLowerCase() == questionTitle.toLowerCase()) {
        return false;
      } else {
        return candidate.label.toLowerCase().includes(input.toLowerCase());
      }
    };
    return (
      <Select
        styles={SelectMenuStylesHidden}
        options={options}
        onChange={(option) => {
          this.onQuestionEdited(option.value, true);
        }}
        inputValue={isNewQuestion ? "" : questionTitle}
        value={{}}
        menuIsOpen={menuIsOpen}
        filterOption={searchOptions}
        noOptionsMessage={() => null}
      />
    );
  }

  onQuestionEdited(question, finishEditing = false) {
    let questionError = false;
    if (!question.question) {
      questionError = this.ERROR__EMPTY_QUESTION;
    }
    this.setState(
      {
        questionError,
        questionInput: question.question || ""
      },
      () => finishEditing && this.textAreaRef.current && this.textAreaRef.current.blur()
    );
  }

  onEditAnswer(answerIndex, answerObject) {
    const { question, questionIndex } = this.props;
    question.selections[answerIndex] = answerObject;
    logger.log("CampaignCreateATS:Child:onEditAnswer", "called", {
      question,
      questionIndex
    });
    this.props.updateQualificationQuestion(questionIndex, question);
  }

  onAddAnswerClicked() {
    const emptyAnswerObject = {
      text: "",
      isDisqualifying: false
    };
    const { questionIndex, question } = this.props;
    logger.log("CampaignCreateATS:Child:onAddAnswerClicked", "called", {
      question,
      questionIndex
    });
    const newQuestionsList = question.selections || [];
    newQuestionsList.push(emptyAnswerObject);
    question.selections = newQuestionsList;
    this.props.updateQualificationQuestion(questionIndex, question);
    this.setState({ hasNewAnswer: true });
  }

  onDeleteAnswerClicked(answerIndex) {
    const { questionIndex, question } = this.props;
    logger.log("CampaignCreateATS:Child:onDeleteAnswerClicked", "called", {
      question,
      questionIndex
    });
    const { selections = [] } = question;
    selections.splice(answerIndex, 1);
    this.props.updateQualificationQuestion(questionIndex, question);
  }

  renderAnswers() {
    const { question, questionIndex, t } = this.props;
    const { hasNewAnswer } = this.state;
    const selections = question.selections || [];
    const selectionsAmount = selections.length;

    let hasDisqError = 0;
    selections.map((answer) => {
      if (answer.isDisqualifying) {
        hasDisqError++;
      }
    });

    return (
      <AnswersSection>
        {selections.map((answer, index) => {
          return (
            <ATSSingleAnswer
              key={questionIndex + "_" + index}
              answer={answer}
              answerIndex={index}
              questionIndex={questionIndex}
              onEditAnswer={this.onEditAnswer.bind(this)}
              onDeleteAnswerClicked={this.onDeleteAnswerClicked.bind(this)}
              isNewAnswer={hasNewAnswer && index == selectionsAmount - 1}
              hasDisqError={hasDisqError}
              hasSingleAnswer={selectionsAmount == 1}
              showCheckBox={!(selectionsAmount - 1 == hasDisqError && !answer.isDisqualifying)}
            />
          );
        })}
        <AddAnswerPlaceholder onClick={this.onAddAnswerClicked.bind(this)}>
          {t("Add answer")}
        </AddAnswerPlaceholder>
      </AnswersSection>
    );
  }

  onFocus(e) {
    const el = e.target;

    if (el.setSelectionRange) {
      // Double the length because Opera is inconsistent about whether a carriage return is one character or two.
      var len = el.value.length * 2;

      // Timeout seems to be required for Blink
      setTimeout(function () {
        el.setSelectionRange(len, len);
      }, 0);
    } else {
      // Doesn't work in Chrome, but Chrome supports setSelectionRange
      // eslint-disable-next-line no-self-assign
      el.value = el.value;
    }
    this.setState({
      isQuestionBeingEdited: true
    });
  }

  onBlur(e) {
    const { questionIndex, question } = this.props;
    this.setState({
      isQuestionBeingEdited: false
    });

    logger.log("CampaignCreateATS:Child:onBlur", "called", {
      question,
      questionIndex,
      questionInput: this.state.questionInput
    });

    this.props.updateQualificationQuestion(questionIndex, {
      ...question,
      question: this.state.questionInput
    });
  }

  render() {
    const { questionError, isQuestionBeingEdited, questionInput } = this.state;
    const { question, questionIndex, t } = this.props;
    const { selections = [] } = question;
    const selectionsAmount = selections.length;

    logger.log("Question:CampaignCreateATS:render", "called", {
      questionIndex,
      selections
    });

    return (
      <QuestionSection>
        <QuestionWrapper>
          <QuestionNumberWrapper> {questionIndex + 1} </QuestionNumberWrapper>
          <QuestionEditing
            ref={this.textAreaRef}
            value={questionInput}
            onKeyDown={this.autosize.bind(this)}
            onChange={(e) => {
              this.onQuestionEdited({
                ...question,
                question: e.target.value,
                source: "custom"
              });
            }}
            onFocus={this.onFocus.bind(this)}
            onBlur={this.onBlur.bind(this)}
            questionError={!isQuestionBeingEdited && questionError}
          />
          <DeleteButtonQuestion
            src="/images/delete-icon.svg"
            onClick={() => {
              this.props.deleteQualificationQuestion(questionIndex);
            }}
          />
        </QuestionWrapper>

        {this.renderHistoricalQuestions()}

        {!selectionsAmount && <FreeFormText>{t("free text field")}</FreeFormText>}

        {this.renderAnswers()}
      </QuestionSection>
    );
  }
}

export default withTranslation()(ATSSingleQuestion);
